require('../css/main.css');
import CookieConsent from './CookieConsent.js';
CookieConsent().check();